import { CurrentUser } from '../../../../current-user/currentUserTypes';

export enum NetworkRequestStatus {
  NONE = 'none',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}

export type ConnectType = 'email' | SocialConnectType;

export type SocialConnectType = 'twitter' | 'google';

export interface NetworkRequest {
  status: NetworkRequestStatus;
  message?: string;
  error?: string;
}

export interface IAccountState {
  forgotPassword: NetworkRequest;
  resetPassword: NetworkRequest;
}

export type Reputation = {
  total: number;
  receivedRankedUp?: number;
  receivedRankedDown?: number;
  rankedDown?: number;
  feature?: number;
  follow?: number;
  mute?: number;
};
